import { makeStyles } from "@material-ui/core";

const FuelSurchargeStyle = makeStyles({
  FuelSurchargeWrapper: {
    "& .primary-btn.blue-btn": {
      marginLeft: "auto",
      marginTop: "20px",
      marginBottom: "20px",
    },
    "& .fuel-charge-holder": {
      display: "flex",
      flexWrap: "wrap",
      "@media(max-width:767px)": {
        display: "block",
      }
    },
    "& .weekly-row-wrapper": {
      "& .MuiBackdrop-root": {
        color: " #fff",
        zIndex: "1200000",
      },
      marginTop: "30px",
      "& .weekly-row": {
        display: "flex",
        flexWrap: "wrap",
        alignItems: "normal !important",
        marginRight: "20px",
        "@media(max-width:767px)": {
          marginRight: "0"
        },
        "& + .weekly-row": {
          marginTop: "24px",
        },
        "& .textfield-wrapper": {
          paddingLeft: "40px !important",
          "& .fuel": {
            width: "250px",
            maxWidth: "100% !important",
            "@media(max-width:767px)": {
              width: "100%",
            }
          },
          "@media(max-width:767px)": {
            paddingLeft: "0px !important",
          },
        },
        "& .error-text": {
          color: "red",
        },
        "& .label-text": {
          paddingRight: "15px",
          paddingTop: "15px",
          margin: "0",
          maxWidth: "170px",
          flex: '0 0 170px !important',
          textAlign: "right",
          "@media(max-width:767px)": {
            maxWidth: "100%",
            flex: "0 0 100% !important",
            paddingRight: "0",
            paddingTop: "0",
            margin: "0 0 10px",
            textAlign: "left",
          },
        },
      },
    },
    "& .date-row-wrapper": {
      marginTop: "30px",
      "& .date-row": {
        display: "flex",
        flexWrap: "wrap",
        "@media(max-width:767px)": {
          display: "block",
        },
        "& .textfield-wrapper": {
          paddingLeft: "40px",
          "& .custom-datepicker": {
            width: "250px",
            "@media(max-width:767px)": {
              width: "100%",
            }
          },
          "@media(max-width:767px)": {
            paddingLeft: "0px !important",
          },
        },
        "& .label-text": {
          flex: "0 0 170px",
          margin: "0",
          maxWidth: "170px",
          paddingRight: "15px",
          paddingTop: "15px",
          textAlign: "right",
          "@media(max-width:767px)": {
            maxWidth: "100%",
            flex: "0 0 100% !important",
            paddingTop: "0",
            paddingRight: "0",
            margin: "0 0 10px",
            textAlign: "left",
          },
        },
      }
    }
  },
});

export { FuelSurchargeStyle };
